import React from 'react';
import styles from './InitiativesDashboardHeader.module.scss';

export interface InitiativesDashboardHeaderProps {}

export const InitiativesDashboardHeader = (
  props: InitiativesDashboardHeaderProps
): React.ReactElement<InitiativesDashboardHeaderProps> => {
  return (
    <div className={styles.initiativesDashboardHeader}>
      <h2 className={styles.title}>Initiatives</h2>
    </div>
  );
};
